/**
 * Ergänzt das von Google injizierte Places-Dropdown um Buchungs-UI-Klassen.
 * Google hängt `.pac-container` an `document.body` – ohne Hook bleibt es beim Standard-Look.
 */

const DROPDOWN_CLASS = "bk-places-dropdown";
const INPUT_ATTR = "data-bk-places-input-id";

let observer: MutationObserver | null = null;
const trackedInputIds = new Set<string>();

function nextInputId(): string {
  return `bk-places-${crypto.randomUUID()}`;
}

function findDropdownForInput(inputId: string): HTMLElement | null {
  return document.querySelector<HTMLElement>(
    `.${DROPDOWN_CLASS}[data-bk-places-for="${inputId}"]`,
  );
}

function linkVisibleDropdown(inputId: string): void {
  const containers = document.querySelectorAll<HTMLElement>(".pac-container");
  for (const container of containers) {
    if (container.classList.contains(DROPDOWN_CLASS)) continue;
    if (container.offsetParent === null && container.style.display === "none") continue;

    container.classList.add(DROPDOWN_CLASS);
    container.dataset.bkPlacesFor = inputId;
    return;
  }
}

function onDomMutation(): void {
  for (const inputId of trackedInputIds) {
    const input = document.querySelector<HTMLInputElement>(`[${INPUT_ATTR}="${inputId}"]`);
    if (!input) continue;
    if (findDropdownForInput(inputId)) continue;
    linkVisibleDropdown(inputId);
  }
}

function ensureObserver(): void {
  if (observer) return;
  observer = new MutationObserver(onDomMutation);
  observer.observe(document.body, { childList: true, subtree: true });
}

function stopObserverIfIdle(): void {
  if (trackedInputIds.size > 0 || !observer) return;
  observer.disconnect();
  observer = null;
}

/** Markiert ein Straßenfeld und verknüpft künftige Places-Dropdowns mit dem Buchungs-Design. */
export function registerPlacesDropdownInput(input: HTMLInputElement): string {
  const inputId = input.getAttribute(INPUT_ATTR) ?? nextInputId();
  input.setAttribute(INPUT_ATTR, inputId);
  trackedInputIds.add(inputId);
  ensureObserver();
  onDomMutation();
  return inputId;
}

export function unregisterPlacesDropdownInput(inputId: string): void {
  trackedInputIds.delete(inputId);
  document
    .querySelectorAll<HTMLElement>(`.${DROPDOWN_CLASS}[data-bk-places-for="${inputId}"]`)
    .forEach((el) => {
      el.classList.remove(DROPDOWN_CLASS);
      delete el.dataset.bkPlacesFor;
    });
  stopObserverIfIdle();
}
